import * as R from 'ramda'
import creditCardType from 'credit-card-type'

import { format } from 'date-fns'
import en from 'date-fns/locale/en-US'
import es from 'date-fns/locale/es'
import enCA from 'date-fns/locale/en-CA'
import { ParsedUrlQuery } from 'querystring'
const locales: { [name: string]: Locale } = {
  en: en,
  'en-CA': enCA,
  es: es,
  'es-ES': es,
}

export function formatDate(value: Date, fmt: string, lng: string) {
  const locale = locales[lng]
  return format(value, fmt, { locale })
}

export function getParamAsString(
  query: ParsedUrlQuery | undefined,
  key: string
): string {
  if (!query) {
    return ''
  }

  const valueOrArray = query[key]
  return Array.isArray(valueOrArray)
    ? <string>R.head(valueOrArray)
    : <string>query[key]
}

export function getParamAsArray(
  query: ParsedUrlQuery | undefined,
  key: string
): string[] {
  if (!query) {
    return []
  }

  const valueOrArray = query[key]
  return Array.isArray(valueOrArray) ? valueOrArray : [<string>query[key]]
}

export function createStrapiMedia(url: string) {
  return {
    data: {
      id: 3,
      attributes: {
        name: 'logo-mcafe.png',
        alternativeText: null,
        caption: null,
        width: 136,
        height: 66,
        formats: null,
        hash: 'logo_mcafe_e793a1fb20',
        ext: '.png',
        mime: 'image/png',
        size: 1.09,
        url: url,
        previewUrl: null,
        provider: 'aws-s3',
        provider_metadata: null,
        createdAt: '2023-01-06T19:43:49.633Z',
        updatedAt: '2023-01-06T19:43:49.633Z',
      },
    },
  }
}

export const formatCurrency = (
  value: number,
  locale: string = 'en-US',
  currency: string = 'USD'
) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(value)
}

export const formatPercentage = (value: number, locale: string = 'en-US') => {
  return new Intl.NumberFormat(locale, {
    style: 'percent',
  }).format(value)
}

export const decodeCardType = (cardNumber: string) => {
  const results = creditCardType(cardNumber)
  const { type } = results[0] || {}

  switch (type) {
    case 'american-express':
      return 'amex'
    case 'mastercard':
      return 'master'
    default:
      return type
  }
}

export const extractNameValues = (
  fullName: string
): { firstName: string; lastName: string } => {
  const [firstName, ...rest] = fullName.split(' ')

  return {
    firstName,
    lastName: rest.join(' '),
  }
}

export const extractExpirationDateValues = (
  expirationDate: string
): { expirationMonth: string; expirationYear: string } => {
  const [expirationMonth, expirationYear, ..._] = expirationDate.split('/')

  return {
    expirationMonth,
    expirationYear: `20${expirationYear}`,
  }
}

export const stripSpaces = (input: string) => {
  return input.replace(/\s/g, '')
}

export const btoa = (str: string) => {
  return Buffer.from(str).toString('base64')
}

export const atob = (b64Encoded: string) => {
  return Buffer.from(b64Encoded, 'base64').toString('binary')
}
